module.exports = __webpack_public_path__ + "static/img/apps_logo-tall.647ed44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apps_logo-tall.png
// module id = pL1n
// module chunks = 13